export default "__VITE_ASSET__d1e69541__"